export function Link({ to, children, onClick, reloadDocument = false, ...props }) {
  const normalizedHref = (typeof to === "string" ? to : "/").replace(/[?&]lang=ar(?=&|$)/i, "").replace(/[?&]$/, "");
  const requestedHref = normalizedHref;
  const isArabicRoute = typeof window !== "undefined" && window.location.pathname.toLowerCase().startsWith("/ar");
  const href = isArabicRoute && requestedHref.startsWith("/") && !requestedHref.startsWith("/ar")
    ? `/ar${requestedHref}`
    : requestedHref;

  const handleClick = (event) => {
    onClick?.(event);
    if (
      event.defaultPrevented ||
      reloadDocument ||
      event.button !== 0 ||
      event.metaKey ||
      event.altKey ||
      event.ctrlKey ||
      event.shiftKey ||
      props.target
    ) {
      return;
    }

    event.preventDefault();
    window.history.pushState({}, "", href);
    window.dispatchEvent(new Event("app:navigate"));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <a {...props} href={href} onClick={handleClick}>
      {children}
    </a>
  );
}
